import React from 'react'
import { faUserCrown } from '@fortawesome/pro-regular-svg-icons/faUserCrown'
import { faUserCrown as faUserCrownSolid } from '@fortawesome/pro-solid-svg-icons/faUserCrown'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import { reverse } from 'src/routes/config'

export default function DebugMenu({ parentIsCollapsed }) {
    return (
        <MainMenuItem
            icon={faUserCrown}
            iconActive={faUserCrownSolid}
            title={'Admin'}
            parentIsCollapsed={parentIsCollapsed}
            isOpen={false}
            to={reverse('admin')}
        />
    )
}
